export class Denuncia{
  id: number;
  nomeDenunciante: string;
  emailDenunciante: string;
  telefoneDenunciante: string;
  chaveAcessoDenunciante: string;
  anonimoDenunciante: number;
  descricao: string;
  envolvidos: string;
  relacaoEntreEnvolvidos: string;
  dataHoraIncidente: string;
  localIncidente: string;
  perfildenunciante_id: number;
  perfildenunciante: string;
  vinculodenunciante_id: number;
  vinculodenunciante: string;
  outroPerfilDenunciante: string;
  outroVinculoDenunciante: string;
  DitensRelIncidente: number[];
  itensTipoIncidenteFinal: number[];
  outroTipoIncidente: string;
  outraRelacaoIncidente: string;
  itensTipoComunicadoFinal: number[];
  outraComunicacaoOutroIncidente: string;
  nomeArquivo: string;
  tipoIncidentes: string[];
  relacaoIncidentes: string[];
  comunicacaoIncidentes: string[];
  descricaoNaoPertinente: string;
  relatado: number;
}



// WEBPACK FOOTER //
// ./src/app/denuncia/denuncia.ts